import React,{Component} from 'react';
import NavListAccordion, {NavListAccordionWrapper} from '../../../../common/NavListAccordion/NavListAccordion';
import {getCountryAccordions,dropDownDataSourceMap,accordionFieldsMap,paymentTypeNarrativeMap,objectToStringFieldMap} from '../../../ProductRequests/CaptureProductCorporateCard/mappingFile';

import {Translations} from '../../../../../utils';
import {eapiClient, aemHostClient, taxonomyHostClient} from '../../../../../restClient';
import CCAccordion from './CCAccordion/CCAccordion';

import {FORM_REFS} from '../../../../../constants';

import './styles.css';

export default class CorporateCard extends Component {
  constructor(props) {
    super(props);
    this.state={
      pageJson : undefined,
      allAccordionAemData: undefined,
      checkboxTaxonomy: undefined
    }

  }

  componentDidMount(){
    //Get the taxonomy to populate labels for checkboxes and radio buttons
    eapiClient("/product/taxonomies/corporate-card")
    .then(({data}) => {
      this.setState({
        checkboxTaxonomy: data
      })
    });

    //Get the pageJSON for various accordions of ACH Credit
    aemHostClient("/aemData/formData/json_corporate-card-all-closed")
    .then(({data}) => {
        this.setState({pageJson: data},()=>{
          let formDataObject = {};
          for(let [accordionKey,accordionContent] of Object.entries(this.state.pageJson.par)){
            if(accordionKey.startsWith('aemform_')){
              formDataObject[accordionContent.name]={formRef: FORM_REFS[accordionContent.formRef]}
            }
          }
          this.getAemAccordionComponents(formDataObject);
       });
    })
  }

  getAemAccordionComponents=(allAccordionPageJson)=>{
    let formRefUrlArray = [];
    let accordionNameObj = {};
    for(let [_key,_val] of Object.entries(allAccordionPageJson)){
      formRefUrlArray.push(_val.formRef);
      accordionNameObj[_key] = {};
    }
    let requests = formRefUrlArray.map(formRefUrl => aemHostClient(formRefUrl));
    Promise.all(requests)
      .then(responses=>{
        let responseCounter = 0;
        for(let accordionNameKey of Object.keys(accordionNameObj)){
            accordionNameObj[accordionNameKey] = responses[responseCounter].data.guideContainer.rootPanel.items;
            responseCounter++;
        }
        this.setState({
          allAccordionAemData: accordionNameObj
        });
      })
      .catch(err=>{console.log('An error occoured in CC: ',err)});
  }

  getPaymentType=(paymentObject)=>{
    if(paymentObject){
      let _splitId = paymentObject.value.split(':');
      return _splitId[_splitId.length-2].toLowerCase();
    }else{
      return undefined;
    }
  }

  renderCCAccordion=(ccItem, pageJson)=>{
    let ccAccordionList = getCountryAccordions((ccItem.country.value.split(':')[ccItem.country.value.split(':').length-2].split('-').join('').toLowerCase()));
    let _ccAccordionJsx = [];

    let _additionalDetailsObject = {
      country: ccItem.country || undefined,
      productOwner: ccItem.productOwner || undefined,
    }

    if(ccAccordionList && ccAccordionList.length > 0){
      for(let ccAccordion of ccAccordionList){
        if(ccItem[ccAccordion] && typeof ccItem[ccAccordion]==='object' ){
          _ccAccordionJsx.push(<CCAccordion
                                        accordionName = {ccAccordion}
                                        accordionData = {ccItem[ccAccordion]}
                                        addDetails = {_additionalDetailsObject}
                                        accordionAemData={this.state.allAccordionAemData[ccAccordion]}
                                        lang = {this.props.lang}
                                        key = {ccAccordion}
                                        taxonomyData={this.state.checkboxTaxonomy}
                                        productReferenceObjects={this.props.productReferenceObjects}
                                        accordionHeading = {this.state.pageJson.par['aemform_'+ccAccordion].title}
                                      />);
        }
      }
    };

    return _ccAccordionJsx;
  }

  getCountryTaxanomy = (val) => {
    let countryList = this.props.countryList;
    if (val !== undefined && countryList !== undefined) {
      let countryItem = countryList.find(x => x.id === val);
      if (countryItem !== undefined) {
        let countryName = countryItem.name;
        return countryName;
      }
    }
  }

  renderCCProducts=( newCorporateCard, pageJson)=>{
    let _ccProductMainJsx=[];

    if(newCorporateCard && newCorporateCard.length > 0 ){
      _ccProductMainJsx = newCorporateCard.map((ccItem,key)=>{
          let tabTitleHtml = (<div>
                                <div className="Title">
                                {`${ccItem.country? this.getCountryTaxanomy(ccItem.country.value):''}`}
                                </div>
                                <div  className="SubTitle">
                                {`${ccItem.corporateCardAgent? ccItem.corporateCardAgent.name:''}`}
                                </div>
                              </div>);

          return (
              <NavListAccordion navAccHeading={tabTitleHtml} key={key}>
              <div className="basic-details-section">
                {this.renderCCAccordion(ccItem, pageJson)}
              </div>
              </NavListAccordion>
          )
      })
    }

    return _ccProductMainJsx;

  }


  render(){
    const  {newCorporateCard, pageJson} = this.props;
    return(
      <div className="gdoc-preview-request-content">
      <span>
      {Translations(pageJson.dynamic_accordion_list_corporateCards.title,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
      </span>
      {this.state.allAccordionAemData?(
        <NavListAccordionWrapper>
          {this.renderCCProducts(newCorporateCard, pageJson)}
        </NavListAccordionWrapper>
      ):''}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/PreviewRequest/Child/CorporateCard/CorporateCard.js